import { render, staticRenderFns } from "./NewCredit.vue?vue&type=template&id=0b820c49&"
import script from "./NewCredit.vue?vue&type=script&lang=js&"
export * from "./NewCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports